export default __webpack_public_path__ + "static/media/captur-colour-5.be087f24.jpg";